var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.text)?_c('span',{class:['sam-span-link-label', _vm.marginBottomClass, 'mt-0']},[_c('a',{staticClass:"sam-link-value",attrs:{"href":_vm.link}},[_vm._v(_vm._s(_vm.text))])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }